import init from './entry'


init(window.__initialState__, true)
